import { create } from 'zustand';
import { Publication } from './types';

interface PublicationStore {
  publications: Publication[];
  isLoading: boolean;
  setPublications: (publications: Publication[]) => void;
  addPublication: (publication: Publication) => void;
  updatePublication: (id: string, updates: Partial<Publication>) => void;
  deletePublication: (id: string) => void;
  setLoading: (loading: boolean) => void;
  getPublicationsByAccount: (accountId: string) => Publication[];
}

export const usePublicationStore = create<PublicationStore>((set, get) => ({
  publications: [],
  isLoading: false,

  setPublications: (publications) => set({ publications }),

  addPublication: (publication) =>
    set((state) => ({
      publications: [publication, ...state.publications],
    })),

  updatePublication: (id, updates) =>
    set((state) => ({
      publications: state.publications.map((pub) =>
        pub.id === id ? { ...pub, ...updates } : pub
      ),
    })),

  deletePublication: (id) =>
    set((state) => ({
      publications: state.publications.filter((pub) => pub.id !== id),
    })),

  setLoading: (loading) => set({ isLoading: loading }),

  getPublicationsByAccount: (accountId) => {
    const { publications } = get();
    return publications.filter((pub) => pub.accountId === accountId);
  },
}));
